import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastLogin'
})
export class LastLoginPipe implements PipeTransform {

  transform(value: string | null | undefined): { text: string, class: string } {
    if (!value) {
      return { text: 'Never', class: 'badge-light' };
    }
    
    try {
      const date = new Date(value);
      const now = new Date();
      const diffTime = Math.abs(now.getTime() - date.getTime());
      const diffMinutes = Math.floor(diffTime / (1000 * 60));
      const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffMinutes < 60) {
        return { text: `${diffMinutes} mins ago`, class: 'badge-light-success' };
      } else if (diffHours < 24) {
        return { text: `${diffHours} hours ago`, class: 'badge-light-warning' };
      } else if (diffDays === 1) {
        return { text: 'Yesterday', class: 'badge-light' };
      } else if (diffDays < 7) {
        return { text: `${diffDays} days ago`, class: 'badge-light' };
      } else {
        return { text: `${Math.ceil(diffDays / 7)} weeks ago`, class: 'badge-light' };
      }
    } catch (error) {
      return { text: 'Invalid date', class: 'badge-light' };
    }
  }
}
